module.exports = __webpack_public_path__ + "b7731a0bd4fb950a698fc8e0e9932f29.svg";